import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function HousingDetail() {
  const { id } = useParams();
  const [h, setH] = useState(null);
  const [amt, setAmt] = useState(50);
  const { user } = useAuth();

  const load = () => http.get(`/housing-projects/${id}`).then((r) => setH(r.data));
  useEffect(() => { load(); }, [id]);

  if (!h) return <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16">Loading…</div>;

  const donate = async () => {
    if (!user) return toast.error("Sign in to sponsor");
    await http.post("/donations", { amount: Number(amt), target_type: "housing_project", target_id: id, message: `Sponsoring ${h.title}` });
    toast.success(`Thank you — $${amt} sponsored (mock).`);
    load();
  };

  return (
    <div data-testid="housing-detail" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-16">
      <div className="rounded-3xl overflow-hidden aspect-[21/9] mb-10">
        <img src={h.image_url} alt={h.title} className="w-full h-full object-cover" />
      </div>
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8">
          <div className="overline">{h.city.toUpperCase()}, {h.country.toUpperCase()} · FAMILY: {h.family_name.toUpperCase()}</div>
          <h1 className="font-display text-4xl md:text-5xl mt-3">{h.title}</h1>
          <p className="mt-5 text-base leading-relaxed" style={{ color: "var(--wofy-text-soft)" }}>{h.description}</p>

          <div className="mt-10">
            <div className="flex items-center justify-between text-sm mb-2">
              <span>Progress</span><span className="font-mono">{h.progress}%</span>
            </div>
            <div className="h-3 w-full rounded-full" style={{ background: "var(--wofy-surface)" }}>
              <div className="h-full rounded-full transition-all duration-500" style={{ width: `${h.progress}%`, background: "var(--wofy-primary)" }} />
            </div>
            <div className="mt-2 flex justify-between text-xs font-mono" style={{ color: "var(--wofy-text-soft)" }}>
              <span>${h.raised.toLocaleString()} raised</span>
              <span>of ${h.cost.toLocaleString()}</span>
            </div>
          </div>

          <h2 className="font-display text-2xl mt-14 mb-4">Sponsors</h2>
          <div className="flex flex-wrap gap-2">
            {h.sponsors.map((s) => <span key={s} className="wofy-tag">{s}</span>)}
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="wofy-card sticky top-24">
            <div className="overline">SPONSOR THIS BUILD</div>
            <div className="font-display text-2xl mt-2">Add to this family&rsquo;s home</div>
            <div className="mt-6 flex gap-2 flex-wrap">
              {[25, 50, 100, 250, 500].map((v) => (
                <button key={v} data-testid={`amt-${v}`} onClick={() => setAmt(v)} className={`rounded-full px-4 py-2 text-sm border ${amt === v ? "bg-[color:var(--wofy-text)] text-[color:var(--wofy-bg)] border-transparent" : ""}`} style={{ borderColor: "var(--wofy-border)" }}>${v}</button>
              ))}
            </div>
            <button data-testid="sponsor-btn" onClick={donate} className="wofy-btn-primary w-full justify-center mt-6">Sponsor ${amt} (mock)</button>
            <p className="mt-3 text-xs text-center" style={{ color: "var(--wofy-text-soft)" }}>Full transparency: every dollar tracked.</p>
          </div>
        </aside>
      </div>
    </div>
  );
}
